import * as React from 'react';
import Modal from '@mui/material/Modal';
import axios from 'axios';
import { useForm, SubmitHandler } from 'react-hook-form';
import { useState } from 'react';
import { useCookies } from 'react-cookie';
import baseUrlApi from '../../../lib/baseUrlApi';
import {useNavigate} from "react-router-dom";
import {ApiRequest} from "../../../Consts/ApiRequest";
import { modalProps } from '../../../Consts/constants';

interface props {
    infoRecno: number;
    closeModal: Function;
};

export default function InfoAdminModalDelete(props: props) {
    const [open, setOpen] = React.useState(false);
    const handleOpen = () => setOpen(true);
    const handleClose = () => setOpen(false);
    const infoRecno = (props.infoRecno);
    const closeModal = props.closeModal;
    const { register, handleSubmit, formState: { errors } } = useForm<props>();
    const [cookies, setCookie, removeCookie] = useCookies(['authority', 'access_token', "siteId", "siteRecno"]);
    const navigate = useNavigate();

    function errorCallback(error:any){
        if (error.response && error.response.status === 401) {
            console.error("Error token error:", error);
            removeCookie('access_token', {path: '/'});
            removeCookie('authority', {path: '/'});
            removeCookie('siteId', {path: '/'});
            removeCookie('siteRecno', {path: '/'});
            navigate("logout");
        }
        console.error("Error fetching dataSite:", error);
    }

    const onSubmit = async () => {
        try {
            const token = cookies.access_token || "";
            let params = {
                "prcKind": 2,
                "infoRecno": infoRecno,
            };
            await ApiRequest.registInfo(params, token, (response: any) => {
                handleClose();
                closeModal();
            }, (error: any) => {
                errorCallback(error);
            });
        } catch (error) {
            console.error("Error fetching data:", error);
            alert("エラーが発生しました");
        }
    };

    return (
        <div>
            <button onClick={handleOpen} className="btn btn-red-line">
                <i className="icon-delete-r">
                </i>削除</button>

            <Modal {...modalProps} open={open}>
                <div className="modal-wrapper" style={{ display: "flex" }} id="modal-message">
                    <div className="modal">
                        <div className="modal-header">
                            <div className="modal-title">
                                削除確認
                            </div>
                            <a onClick={handleClose} className="modal-close"></a>
                        </div>
                        <div className="modal-body">
                            <div className="edit-box">
                                本当に削除してもよろしいですか？
                            </div>
                        </div>
                        <div className="modal-footer">
                            <div className="model-action-sub">
                            </div>
                            <div className="model-action-main">
                                <button onClick={handleClose} className="btn btn-blue-line">
                                    キャンセル
                                </button>
                                <form onSubmit={handleSubmit(onSubmit)}>
                                    <button className="btn btn-red-line">
                                        <i className="icon-delete-r"></i>確定
                                    </button>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
        </div>
    );
};
